// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__GlT6n","addWidgetButton":"Header_addWidgetButton__MzxiF","dashboardTabs":"Header_dashboardTabs__2h-gN","active":"Header_active__27umn"};